import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import { IS_DUAL, IS_ELEC, IS_GAS } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'

const useAddressPodValidation = () => {
  const { t } = useTranslation()
  const { country } = useSelector(selectAuthData)
  const { addErrorToContract, removeContractError } = useFormStatus()

  const clearPodErrors = contractId => {
    removeContractError(contractId, 'address_pod_id_elec')
    removeContractError(contractId, 'address_pod_id_gas')
    removeContractError(contractId, 'address_pod_id_dual')
  }

  const validateAddressPod = ({ contractId, addressId, energyType, hasElectricityMeter, hasGasMeter }) => {
    if (country !== 'fr' || !addressId) {
      clearPodErrors(contractId)
      return
    }

    const isElecOrDual = energyType === IS_ELEC || energyType === IS_DUAL
    const isGasOrDual = energyType === IS_GAS || energyType === IS_DUAL
    const missingElec = isElecOrDual && !hasElectricityMeter
    const missingGas = isGasOrDual && !hasGasMeter

    if (missingElec && missingGas) {
      addErrorToContract(contractId, { address_pod_id_dual: t('subscriptionForm:validation_errors_v2.address_pod_id_dual') })
      removeContractError(contractId, 'address_pod_id_elec')
      removeContractError(contractId, 'address_pod_id_gas')
      return
    }

    if (missingElec) {
      addErrorToContract(contractId, { address_pod_id_elec: t('subscriptionForm:validation_errors_v2.address_pod_id_elec') })
      removeContractError(contractId, 'address_pod_id_gas')
      removeContractError(contractId, 'address_pod_id_dual')
      return
    }

    if (missingGas) {
      addErrorToContract(contractId, { address_pod_id_gas: t('subscriptionForm:validation_errors_v2.address_pod_id_gas') })
      removeContractError(contractId, 'address_pod_id_elec')
      removeContractError(contractId, 'address_pod_id_dual')
      return
    }

    clearPodErrors(contractId)
  }

  return { validateAddressPod }
}

export default useAddressPodValidation
